module.exports = __webpack_public_path__ + "img/68.249e0a3a.jpg";